// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"faaf1cb7","455":"b52fa6e0","977":"b1e9a1fa"}[chunkId] + ".chunk.js";
};